import useControlledState from '@quid/react-use-controlled-state';
import React, { FC, useEffect, useState } from 'react';
import { ExpandedChildrenWrapper, MoreButton, NormalChildrenWrapper } from './OverflowContainer.styled';
import { useOverflowContainer } from './useOverflowContainer';

export interface OverflowContainerProps {
  defaultIsExpanded?: boolean;
  isExpanded?: boolean;
  onExpandedChange?: (value: boolean) => void;
}

export const OverflowContainer: FC<React.PropsWithChildren<OverflowContainerProps>> = ({ children, isExpanded, defaultIsExpanded, onExpandedChange }) => {
  const [expanded, setExpanded] = useControlledState(defaultIsExpanded, isExpanded, onExpandedChange);
  const [isOverflow, setIsOverflow] = useState(false);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  const ref = useOverflowContainer(setIsOverflow, setHeight, setWidth);

  useEffect(() => {
    if (expanded && !isOverflow) {
      setExpanded(false);
    }
  }, [expanded, isOverflow, setExpanded]);

  return (
    <>
      <NormalChildrenWrapper data-test="normal-children-wrapper" ref={ref} isHidden={!!expanded} height={height}>
        {children}
      </NormalChildrenWrapper>
      {expanded && (
        <ExpandedChildrenWrapper data-test="expanded-children-wrapper" width={width}>
          {children}
        </ExpandedChildrenWrapper>
      )}
      {(expanded || isOverflow) && <MoreButton expanded={!!expanded} onClick={() => setExpanded(!expanded)} />}
    </>
  );
};
